
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const constantRouterMap = [  
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/',
    component: resolve => require(['@/views/index.vue'], resolve),
    children: [
      {
        path: 'home',
        component: resolve => require(['@/views/home/index.vue'], resolve),
      },
      // {
      //   path: 'product',
      //   component: resolve => require(['@/views/product/index.vue'], resolve),
      // },
      {
        path: 'product',
        component: resolve => require(['@/views/product/listPage.vue'], resolve),
      },
      {
        path: 'productDetail',
        component: resolve => require(['@/views/product/detail.vue'], resolve),
      },
      // {
      //   path: 'solution',
      //   component: resolve => require(['@/views/solution/index.vue'], resolve),
      // },
      {
        path: 'solution',
        component: resolve => require(['@/views/solution/detail.vue'], resolve),
      },
      // {
      //   path: 'ext-service',
      //   component: resolve => require(['@/views/ext/index.vue'], resolve),
      // },
      {
        path: 'ext-service',
        component: resolve => require(['@/views/ext/detail.vue'], resolve),
      },
      {
        path: 'news',
        component: resolve => require(['@/views/news/index.vue'], resolve),
      },
      {
        path: 'newsDetail',
        component: resolve => require(['@/views/news/detail.vue'], resolve),
      },
      {
        path: 'about',
        component: resolve => require(['@/views/about/index.vue'], resolve),
      },
      {
        path: 'contact',
        component: resolve => require(['@/views/contact/index.vue'], resolve),
      },
    ]
  }, 
]

export default new Router({
  mode:'hash',
  // base: '/dist/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})